import { EurekaPackageType } from '@eureka/services/src/apis/common.api.types';
import type { IOpenClueReportOptions } from '../types';

export const GEETEST_MESSAGEAUTHENTICATION = process.env.VUE_APP_GEETEST_MESSAGEAUTHENTICATION;
export const SMS_CODE_ERROR = 9030119;
export const HUBSPOT_IFRAME_URL = 'https://js.hsforms.net/forms/embed/v2.js';
export const HUBSPOT_REGION = 'na1';

/* =============== AIR west form 配置 =============== */
const AIR_HUBSPOT_PORTAL_ID = '2149185';
const AIR_HUBSPOT_FORM_ID = 'c576825a-ecd3-4aea-bb2d-0b496d29c0f6';

/* =============== MATERIAL west form 配置 =============== */
const MATERIAL_HUBSPOT_PORTAL_ID = '2149185';
const MATERIAL_HUBSPOT_FORM_ID = 'e47b1ff1-b32e-4e35-8c04-f299dc7a172d';

/* =============== GENERAL west form 配置（TODO: 需要产品提供，未合并前，材料和IP表单是一个） =============== */
const GENERAL_HUBSPOT_PORTAL_ID = '2149185';
const GENERAL_HUBSPOT_FORM_ID = '9f91d0dd-2f7f-4ee1-884f-e7591f3ef98f';

/**
 * 获取升级目标套餐的表单配置映射
 * @param edition
 * @returns Partial<IOpenClueReportOptions>
 */
export function getTargetEditionFormConfig(edition: EurekaPackageType) {
    const config: Record<string, IOpenClueReportOptions> = {
        [EurekaPackageType.AIR_COMMERCIAL]: { // AIR 企业版
            hubspotPortalId: AIR_HUBSPOT_PORTAL_ID,
            hubspotFormId: AIR_HUBSPOT_FORM_ID,
            packageType: EurekaPackageType.AIR_COMMERCIAL,
        },
        [EurekaPackageType.MATERIAL_COMMERCIAL]: { // 材料企业版
            hubspotPortalId: MATERIAL_HUBSPOT_PORTAL_ID,
            hubspotFormId: MATERIAL_HUBSPOT_FORM_ID,
            packageType: EurekaPackageType.MATERIAL_COMMERCIAL,
        },
        [EurekaPackageType.IP_COMMERCIAL]: { // 范域(IP)企业版
            hubspotPortalId: GENERAL_HUBSPOT_PORTAL_ID,
            hubspotFormId: GENERAL_HUBSPOT_FORM_ID,
            packageType: EurekaPackageType.IP_COMMERCIAL,
        },
    };

    return config[edition];
}
